module.exports = __webpack_public_path__ + "img/dst stepping 2001.457a04b9.png";